module.exports = __webpack_public_path__ + "media/customizations/default/chat-bubble 2-184f41167955f49bfe91d8ecf6e0eb11.png";